"use strict";

var _defineProperty = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseWearable = void 0;

var validation_1 = require("../../validation");

var wearable_category_1 = require("../../dapps/wearable-category");

var i18n_1 = require("./i18n");

var representation_1 = require("./representation");

var metrics_1 = require("./metrics");

var displayable_1 = require("../shared/displayable");
/** @alpha */


var BaseWearable;

(function (BaseWearable) {
  BaseWearable.schema = {
    type: 'object',
    properties: _objectSpread(_objectSpread({}, displayable_1.displayableProperties), {}, {
      id: {
        type: 'string'
      },
      descriptions: {
        type: 'array',
        items: i18n_1.I18N.schema,
        minItems: 1
      },
      names: {
        type: 'array',
        items: i18n_1.I18N.schema,
        minItems: 1
      },
      data: {
        type: 'object',
        properties: {
          replaces: {
            type: 'array',
            items: wearable_category_1.WearableCategory.schema
          },
          hides: {
            type: 'array',
            items: wearable_category_1.WearableCategory.schema
          },
          tags: {
            type: 'array',
            items: {
              type: 'string',
              minLength: 1
            }
          },
          representations: {
            type: 'array',
            items: representation_1.WearableRepresentation.schema,
            minItems: 1
          },
          category: wearable_category_1.WearableCategory.schema
        },
        additionalProperties: false,
        required: ['replaces', 'hides', 'tags', 'representations', 'category']
      },
      thumbnail: {
        type: 'string'
      },
      image: {
        type: 'string'
      },
      metrics: _objectSpread(_objectSpread({}, metrics_1.Metrics.schema), {}, {
        nullable: true
      })
    }),
    additionalProperties: false,
    required: ['id', 'descriptions', 'names', 'data', 'thumbnail', 'image']
  }; // Returns true only if there are no entries with the same locale

  BaseWearable.validateDuplicatedLocales = function (i18ns) {
    return i18ns.every(function (_ref, index) {
      var code = _ref.code;
      return i18ns.findIndex(function (i18n) {
        return i18n.code === code;
      }) === index;
    });
  };

  var schemaValidator = (0, validation_1.generateValidator)(BaseWearable.schema);

  BaseWearable.validate = function (wearable) {
    return schemaValidator(wearable) && BaseWearable.validateDuplicatedLocales(wearable.descriptions) && BaseWearable.validateDuplicatedLocales(wearable.names);
  };
})(BaseWearable = exports.BaseWearable || (exports.BaseWearable = {}));